import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, OnInit, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { InvoiceFormComponent } from '../../components/invoice/invoice-form/invoice-form.component';
import { Invoice } from '../../models/invoice';
import { InvoiceService } from '../../services/invoice.service';
import { ModalService } from '../../services/modal/modal.service';

@Component({
  selector: 'app-update-invoice',
  imports: [ReactiveFormsModule, CommonModule, InvoiceFormComponent],
  templateUrl: './update-invoice.component.html',
  styleUrl: './update-invoice.component.scss',
})
export class UpdateInvoiceComponent implements OnInit {
  buttonText = 'Update';

  errorProvider: Subject<string | undefined> = new Subject();
  submittingProvider: Subject<boolean> = new Subject();

  public form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private invoiceService: InvoiceService,
    private modalService: ModalService,
    private vcr: ViewContainerRef,
    private router: Router,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    let invoiceRaw = localStorage.getItem('edit');
    localStorage.removeItem('edit');

    if (invoiceRaw == null) {
      this.router.navigateByUrl('dashboard/invoices');
      this.modalService.showErrorDialog(this.vcr, 'No invoice were selected!');
    } else {
      let invoice: Invoice = JSON.parse(invoiceRaw);
      this.form = this.fb.group({
        id: this.fb.control(invoice.id, [
          Validators.required,
          Validators.min(1),
        ]),
        partner: this.fb.control(invoice.partner.id, Validators.required),
        invoiceNumber: this.fb.control(
          invoice.invoiceNumber.split('/')[0],
          Validators.required
        ),
        status: this.fb.control(invoice.status.id, Validators.required),
        date: this.fb.control(invoice.date, Validators.required),
        deliveryDate: this.fb.control(
          invoice.deliveryDate,
          Validators.required
        ),
        deadline: this.fb.control(invoice.deadline, Validators.required),
        amount: this.fb.control(invoice.amount, Validators.required),
        article: this.fb.control(null),
        articles: this.fb.array([], Validators.required),
      });

      let articles: FormArray = this.form.get('articles') as FormArray;

      invoice.articles.forEach((a) => {
        articles.push(
          this.fb.group({
            articleId: this.fb.control(a.articleId, [
              Validators.required,
              Validators.min(1),
            ]),
            quantity: this.fb.control(a.quantity, [
              Validators.required,
              Validators.min(1),
            ]),
            price: this.fb.control(a.price, [
              Validators.required,
              Validators.min(0.0),
            ]),
            unitOfMeasurement: this.fb.control(a.unitOfMeasurement),
            name: this.fb.control(a.name),
          })
        );
      });
    }
  }

  updateInvoice() {
    if (this.form.valid) {
      this.errorProvider.next(undefined);
      this.submittingProvider.next(true);

      this.invoiceService
        .updateInvoice(this.form.value)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (resp) => {
            this.submittingProvider.next(false);
            this.router.navigateByUrl('dashboard/invoices');
          },
          error: (err: HttpErrorResponse) => {
            this.submittingProvider.next(false);
            this.modalService.showErrorDialog(this.vcr, err.error.message);
          },
        });
    } else {
      this.errorProvider.next('Please fill all field properly.');
    }
  }
}
